import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSubscriptionPlans,
  deleteSubscriptionPlan,
  updateSubscriptionPlan,  // Import the new update thunk
} from "../thunks/subscriptionPlanThunks";

const subscriptionPlanSlice = createSlice({
  name: "subscriptionPlans",
  initialState: {
    plans: [],
    pagination: {},
    loading: false,
    error: null,
  },
  reducers: {
    clearSubscriptionPlans: (state) => {
      state.plans = [];
      state.pagination = {};
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchSubscriptionPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubscriptionPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload.plans || [];
        state.pagination = action.payload.pagination || {};
      })
      .addCase(fetchSubscriptionPlans.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Failed to fetch subscription plans";
      })

      // DELETE
      .addCase(deleteSubscriptionPlan.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteSubscriptionPlan.fulfilled, (state, action) => {
        const deletedId = action.payload.planId;
        state.plans = state.plans.filter(
          (p) => p.id !== deletedId && p._id !== deletedId
        );
      })
      .addCase(deleteSubscriptionPlan.rejected, (state, action) => {
        state.error =
          action.payload?.message || "Failed to delete subscription plan";
      })

      // UPDATE
      .addCase(updateSubscriptionPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSubscriptionPlan.fulfilled, (state, action) => {
        state.loading = false;
        const updatedPlan = action.payload;
        state.plans = state.plans.map((plan) =>
          plan.id === updatedPlan.id ? updatedPlan : plan
        );
      })
      .addCase(updateSubscriptionPlan.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Failed to update subscription plan";
      });
  },
});

export const { clearSubscriptionPlans } = subscriptionPlanSlice.actions;
export default subscriptionPlanSlice.reducer;
